<template>
    <div class="dvw-legend">
        <span v-for="item in items" :key="item.symbol" class="dvw-legend__item">
            <span class="dvw-legend__symbol" :class="item.class">{{ item.symbol }}</span>
            <span class="dvw-legend__label">{{ item.label }}</span>
        </span>
    </div>
</template>

<script setup>
const items = [
    { symbol: '#', label: 'Очко / отлично', class: 'q-perfect' },
    { symbol: '+', label: 'Позитивно', class: 'q-positive' },
    { symbol: '!', label: 'Нейтрально', class: 'q-neutral' },
    { symbol: '-', label: 'Плохо', class: 'q-negative' },
    { symbol: '/', label: 'Блок / на ту сторону', class: 'q-slash' },
    { symbol: '=', label: 'Ошибка', class: 'q-error' },
];
</script>
